const locale: Locale = {
  ko: {
    category: '분류',
    title: '제목',
    duration: '청원 기간',
    consent: '참여 인원',
    empty: '청원이 없습니다.',

    people: '명',
  },
  en: {
    category: 'category',
    title: 'title',
    duration: 'duration',
    consent: 'supporters',
    empty: "There're no petitions.",

    people: 'agreed',
  },
}

export default locale
